import { GlobalToken } from 'antd';

export const ANIMATION_SPEED = 0.5;
export const EDGES_WIDTH_PERCENT = 16.2601626;

export const getLimitedRelativePosition = (originalValue, min, max, addSideGaps) => {
  const positionWithSideGapsOffset = () => {
    const adjustedMax = max > min ? max : min;
    const adjustedMin = max > min ? min : max;
    return originalValue < adjustedMin
      ? -EDGES_WIDTH_PERCENT
      : originalValue > adjustedMax
      ? 100 + EDGES_WIDTH_PERCENT
      : ((originalValue - adjustedMin) / (adjustedMax - adjustedMin)) * 100;
  };
  if (originalValue == null) return 0;
  if (max > min) {
    if (addSideGaps) {
      return positionWithSideGapsOffset();
    }
    return originalValue < min ? 0 : originalValue > max ? 100 : ((originalValue - min) / (max - min)) * 100;
  }
  //Handle a reversed slider (going down in values instead of up)
  if (addSideGaps) {
    return positionWithSideGapsOffset();
  }
  return originalValue > min ? 0 : originalValue < max ? 100 : ((min - originalValue) / (min - max)) * 100;
};

export const getBeforeBackgroundColor = (
  value: number,
  min: number,
  max: number,
  highlightSlider: boolean,
  token: GlobalToken,
  backgroundColor: string = token.colorPrimary,
): string => {
  const referenceMinMaxValue = max > min ? min : max;
  return value >= referenceMinMaxValue
    ? highlightSlider
      ? backgroundColor
      : token.colorBorder
    : token.colorBorderSecondary;
};

export const getAfterBackgroundColor = (
  value: number,
  min: number,
  max: number,
  highlightSlider: boolean,
  token: GlobalToken,
  backgroundColor: string = token.colorPrimary,
): string => {
  const referenceMinMaxValue = max > min ? max : min;
  return value > referenceMinMaxValue
    ? highlightSlider
      ? backgroundColor
      : token.colorBorder
    : token.colorBorderSecondary;
};
